import React, { useEffect, useState } from 'react';
import { Button, Table, Input, Tooltip, Breadcrumb, Avatar, Switch } from 'antd';
import { toast } from 'react-toastify';
import { HomeOutlined } from '@ant-design/icons';
import { fetchUsers } from '../../../../services/users/usersApi';
import AjouterUser from './modals/AjouterUser';
import EditUser from './modals/editUser';

const Users = () => {
    const [users, setUsers] = useState([]);
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage] = useState(10);
    const [isOpenAddModal, setIsOpenAddModal] = useState(false);
    const [isOpenEditModal, setIsOpenEditModal] = useState(false);
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const url_media = process.env.REACT_APP_MEDIA_URL||"https://api.masterfut.com/storage";

    useEffect(() => {
        loadUsers();
    }, [search, currentPage]);

    const loadUsers = () => {
        fetchUsers(search, perPage, currentPage)
            .then((response) => {
                setUsers(response.data.users);
                setTotalRows(response.data.totalRows);
                setLoading(false);
            })
            .catch((error) => {
                toast.error('Error fetching users.');
                setLoading(false);
            });
    };

    const handleEtatChange = (userId, currentEtat) => {
        const newEtat = currentEtat === 'active' ? 'desactive' : 'active';
        toast.success(`User status updated to ${newEtat}`);
    };

    const handleOpenEditUser = (user) => {
        setUser(user);
        setIsOpenEditModal(true);
    };

    const openConfirmDeleteModal = (user) => {
        // Logic to open delete confirmation modal
    };

    const columns = [
        {
            title: 'Username',
            dataIndex: 'username',
            key: 'username',
            render: (username, user) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    
                    <Avatar
                        src={user.photo_profil ? `${url_media}/${user.photo_profil}` : undefined}
                        style={{
                            background: user.photo_profil ? undefined : "var(--primary-color) !important",
                            color: 'white',
                        }}
                    >
                        <h5 style={{ marginTop: 1 }}>{user.photo_profil ? null : username.charAt(0).toUpperCase()}</h5>
                    </Avatar>
                    <span style={{ marginLeft: 8 }}>{username}</span>
                </div>
            ),
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Role',
            dataIndex: 'roles',
            key: 'roles',
            filters: [
                { text: 'Admin', value: 'admin' },
                { text: 'Client', value: 'client' },
                { text: 'Agence', value: 'agence' },
            ],
            onFilter: (value, record) => record.roles && record.roles.some(role => role.name === value),
            render: (roles) => roles && roles.length > 0 ? roles[0].name : '-',
        },
        {
            title: 'Etat',
            dataIndex: 'etat',
            key: 'etat',
            width: 160,
            align: 'center',
            filters: [
                { text: 'Active', value: 'active' },
                { text: 'Desactive', value: 'desactive' },
            ],
            onFilter: (value, record) => record.etat.indexOf(value) === 0,
            render: (etat, user) => (
                <label className="custom-control ios-switch">
                    <Switch
                        onChange={() => handleEtatChange(user.id, etat)}
                        checked={etat === "active"}
                        style={{
                            backgroundColor: etat === "active" ? "green" : ""
                        }}
                    />
                    <span className="ios-switch-control-indicator"></span>
                </label>
            ),
        },
        {
            title: 'Actions',
            dataIndex: 'actions',
            align: 'center',
            key: 'actions',
            render: (text, user) => (
                <span>
                    <Tooltip title="Edit">
                        <Button shape="circle" className="m-1" onClick={() => handleOpenEditUser(user)}>
                            <i className="bi bi-pencil-square"></i>
                        </Button>
                    </Tooltip>
                    <Tooltip title="Delete">
                        <Button danger shape="circle" className="m-1" onClick={() => openConfirmDeleteModal(user)}>
                            <i className="bi bi-trash"></i>
                        </Button>
                    </Tooltip>
                </span>
            ),
        },
    ];

    return (
        <>
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h4 className='col-lg-11'>
                        <div className="mb-2">
                            <i className="bx bx-user me-2" />
                            <h3 style={{color:"var(--primary-color3) !important"}}>Users</h3>
                        </div>
                        <Breadcrumb>
                            <Breadcrumb.Item>
                                <HomeOutlined />
                            </Breadcrumb.Item>
                            <Breadcrumb.Item style={{color:"var(--primary-color3) !important"}}>Users</Breadcrumb.Item>
                        </Breadcrumb>
                    </h4>
                    <Button onClick={() => setIsOpenAddModal(true)} style={{ backgroundColor: 'var(--primary-color5)', color: "white" }}>
                        <span>Ajouter</span>
                    </Button>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '10px 0' }}>
                    <Input
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Rechercher"
                        value={search}
                        suffix={<i className="bi bi-search" />}
                        style={{ width: '200px' }}
                    />
                </div>
                <Table
                    dataSource={users}
                    columns={columns}
                    pagination={{ current: currentPage, total: totalRows, pageSize: perPage, onChange: setCurrentPage }}
                    scroll={{ x: 1000 }}
                    loading={loading}
                />
            </div>
            <AjouterUser isOpen={isOpenAddModal} onClose={() => setIsOpenAddModal(false)} onSubmit={loadUsers} />
            <EditUser 
                isOpen={isOpenEditModal} 
                onClose={() => setIsOpenEditModal(false)} 
                onSubmit={loadUsers} 
                user={user} 
            />
        </>
    );
};

export default Users;
